"use client";
import { MapBlock as MapBlockTypes } from "@/payload-types";
import dynamic from "next/dynamic";
import { useMemo } from "react";

const MapBlock: React.FC<MapBlockTypes> = (props) => {
  const Map = useMemo(() => {
    return dynamic(() => import("@onclicks/sharedcomponents/ui/LeafletMap"), {
      loading: () => <p>A map is loading</p>,
      ssr: false,
    });
  }, []);
  return (
    <div className="w-full min-h-fit h-full">
      <Map longitude={props.longitude} latitude={props.latitude} />
    </div>
  );
};

export { MapBlock };
